export const apiEndpoints = {
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  backendAwsUrl: process.env.REACT_APP_BACKEND_AWS_URL,
  cognitoUrl: process.env.REACT_APP_COGNITO_URL,
  cognitoClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  supportAccessApiBaseUrl:
    process.env.REACT_APP_SUPPORT_ACCESS_API_BASE_URL ||
    process.env.REACT_APP_SUPPORT_HUB_URL ||
    "https://123crm-hub.zp.123zap.com.br",
  aiWebhookUrl: "https://api.123zap.com.br",
};
